import {
    clearKeyword,
    clearSelection,
    setKeyword,
    setPage,
    setPageSize,
} from '../reducers';

import {
    selectionSelector,
    selectVisibility,
    visibilityStateSelector,
} from '../selectors';

import {columns} from '../tables/columns';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {
    useDeleteDomainNameMutation,
    useDomainNamesQuery
} from './useDomainNamesQuery';

// FNP-942: records come from React Query; selection, paging and keyword stay in
// Redux. The return shape is unchanged so the table, buttons, inputs and the
// dashboard widget that consume this hook did not have to change.
export const useDomainNames = (registrarId?: string) => {

    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));
    const visibility = useAppSelector((state) => visibilityStateSelector(state));

    const {
        data,
        isLoading,
        refetch
    } = useDomainNamesQuery();

    const deleteMutation = useDeleteDomainNameMutation();

    const {
        items,
        visibleItems,
        limit,
        keyword,
        page,
        totalPages,
        visibleCount,
    } = selectVisibility(visibility, data ?? [], registrarId);

    // FETCH
    const fetchRecords = () => {
        refetch();
    };

    const deleteRecords = () => {
        if (Object.keys(selection).length > 0) {
            for (const key in selection) {
                deleteMutation.mutate(key);
            }
            // Clear the checkboxes once the deletions are issued — otherwise the
            // selection keeps naming records that no longer exist.
            dispatch(clearSelection());
        }
    };


    // FILTERING AND PAGING
    const handleFilterByKeyword = (keyword: string) => {
        if (keyword !== '') {
            dispatch(setKeyword(keyword));
        } else {
            dispatch(clearKeyword());
        }
    };

    const handleItemsPerPageChange = (pageSize: string | null) => {
        dispatch(setPageSize(pageSize));
    };

    const handlePageChange = (page: number) => {
        dispatch(setPage(page));
    };

    // BATCH ACTIONS
    const handleBatchActionCancel = () => {
        dispatch(clearSelection());
    };

    return {
        items,
        visibleItems,
        limit,
        loading: isLoading,
        keyword,
        page,
        totalPages,
        visibleCount,
        columns,
        fetchRecords,
        deleteRecords,
        handleFilterByKeyword,
        handleItemsPerPageChange,
        handleBatchActionCancel,
        handlePageChange,
    };
};
